import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import VoteRegistrationDetails from './VoteRegistrationDetails';
import VoteRegistrationSuccess from './VoteRegistrationSuccess';
import VoteRegistrationSuccessFinal from './VoteRegistrationSuccessFinal';
import VoteRegistrationUnsuccess from './VoteRegistrationUnsuccess';
import VoteRegistrationStep1 from './VoteRegistrationStep1';
import VoteRegistrationStep2 from './VoteRegistrationStep2';
import VoteRegistrationStep3 from './VoteRegistrationStep3';
import VoteRegistrationStep4 from './VoteRegistrationStep4';
import VoteRegistrationStep5 from './VoteRegistrationStep5';
import VoteRegistrationStep6 from './VoteRegistrationStep6';
import VoteRegistrationStep7 from './VoteRegistrationStep7';
import VoteRegistrationStep8 from './VoteRegistrationStep8';

const RegisterForVote = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.key} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/(voteRegistration|voteRegistration/start)"
                            name="VoteRegistrationDetails"
                            exact
                            component={VoteRegistrationDetails}
                        />
                        <Route
                            path="/voteRegistration/success"
                            name="VoteRegistrationSuccess"
                            exact
                            component={VoteRegistrationSuccess}
                        />
                        <Route
                            path="/voteRegistration/successFinal"
                            name="VoteRegistrationSuccessFinal"
                            exact
                            component={VoteRegistrationSuccessFinal}
                        />
                        <Route
                            path="/voteRegistration/unsuccess"
                            name="VoteRegistrationUnsuccess"
                            exact
                            component={VoteRegistrationUnsuccess}
                        />
                        <Route
                            path="/voteRegistration/step1"
                            name="VoteRegistrationStep1"
                            exact
                            component={VoteRegistrationStep1}
                        />
                        <Route
                            path="/voteRegistration/step2"
                            name="VoteRegistrationStep2"
                            exact
                            component={VoteRegistrationStep2}
                        />
                        <Route
                            path="/voteRegistration/step3"
                            name="VoteRegistrationStep3"
                            exact
                            component={VoteRegistrationStep3}
                        />
                        <Route
                            path="/voteRegistration/step4"
                            name="VoteRegistrationStep4"
                            exact
                            component={VoteRegistrationStep4}
                        />
                        <Route
                            path="/voteRegistration/step5"
                            name="VoteRegistrationStep5"
                            exact
                            component={VoteRegistrationStep5}
                        />
                        <Route
                            path="/voteRegistration/step6"
                            name="VoteRegistrationStep6"
                            exact
                            component={VoteRegistrationStep6}
                        />
                        <Route
                            path="/voteRegistration/step7"
                            name="VoteRegistrationStep7"
                            exact
                            component={VoteRegistrationStep7}
                        />
                        <Route
                            path="/voteRegistration/step8"
                            name="VoteRegistrationStep8"
                            exact
                            component={VoteRegistrationStep8}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default RegisterForVote;



// WEBPACK FOOTER //
// ./src/containers/VoteRegistration/VoteRegistration.jsx